// extracted by mini-css-extract-plugin
export default {"container":"signin_container__umu6v","card":"signin_card__IGIOZ","title":"signin_title__WZ5uF","link":"signin_link__FKPUk","button":"signin_button__bWBjV"};